<template>
  <div class="userLayout">
    <Menu></Menu>
    <app-main></app-main>
  </div>
</template>

<script>
import { AppMain, Menu } from './components';
export default {
  components: { AppMain, Menu }
};
</script>

<style lang="less">
.userLayout {
}
</style>
